import React, { useEffect, useMemo, useContext } from "react";  
import { useNetworkingHooks } from "../Helpers/NetworkMessaging";
import Context from "../Context/Context";

export default function useControllerBase(props) {
    const context = useContext(Context)
    const {SendPressButtonToServer, SendReleaseButtonToServer, SendAxisToServer} = useNetworkingHooks(context.user);

    const bgColor = useMemo(() => {
       if(context.user.playerColorDark == null || context.user.playerColorDark.trim() === '') return '#2A2A2D';
       else return context.user.playerColorDark;
    }, [context]);

    const buttonGlow = useMemo(() => {
        if(context.user.playerColorBright == null || context.user.playerColorBright.trim() === '') return '#2f9da1 0%, #185d60 85%';
        else return `${context.user.playerColorBright} 0%, ${context.user.playerColor} 85%`;
    }, [context]);

    const joystickGlow = useMemo(() => {
        if(context.user.playerColorBright == null || context.user.playerColorBright.trim() === '') return '#2f9da1 0%, #185d60 25%, #2A2A2D 50%';
        else return `${context.user.playerColorBright} 0%, ${context.user.playerColorDark} 25%, #2A2A2D 50%`
    }, [context]);

    return{      
        // 1
        onTouchStart_Button_1() {           
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Gas");
        },
        onTouchEnd_Button_1() {
            SendReleaseButtonToServer("Gas");
        },

        // 2
        onTouchStart_Button_2() {
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer('Boost');
        },
        onTouchEnd_Button_2() {
            SendReleaseButtonToServer("Boost");
        },

        // 3,
        onTouchStart_Button_3(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Brake");
        },
        onTouchEnd_Button_3(){
            SendReleaseButtonToServer("Brake");
        },

        // 4
        onTouchStart_Button_4(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Unstuck");
        },
        onTouchEnd_Button_4(){
            SendReleaseButtonToServer("Unstuck");
        },

        // 5
        onTouchStart_Button_5(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Button_5");
        },
        onTouchEnd_Button_5(){
            SendReleaseButtonToServer("Button_5");
        },

        // 6
        onTouchStart_Button_6(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Button_6");
        },
        onTouchEnd_Button_6(){
            SendReleaseButtonToServer("Button_6");
        },

        // 7
        onTouchStart_Button_7(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Button_7");
        },
        onTouchEnd_Button_7(){
            SendReleaseButtonToServer("Button_7");
        },

        // 8
        onTouchStart_Button_8(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Button_8");
        },
        onTouchEnd_Button_8(){
            SendReleaseButtonToServer("Button_8");
        },

        // Up
        onTouchStart_Button_UP(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Button_UP");
        },
        onTouchEnd_Button_UP(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(50);
            }
            SendReleaseButtonToServer("Button_UP");
        },

        // Down
        onTouchStart_Button_DOWN(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Button_DOWN");
        },
        onTouchEnd_Button_DOWN(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(50);
            }
            SendReleaseButtonToServer("Button_DOWN");
        },

        // Left
        onTouchStart_Button_LEFT(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Button_LEFT");
        },
        onTouchEnd_Button_LEFT(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(50);
            }
            SendReleaseButtonToServer("Button_LEFT");
        },

        // Right
        onTouchStart_Button_RIGHT(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Button_RIGHT");
        },
        onTouchEnd_Button_RIGHT(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(50);
            }
            SendReleaseButtonToServer("Button_RIGHT");
        },

        // Menu
        onTouchStart_Button_MENU(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Button_MENU");
        },
        onTouchEnd_Button_MENU(){
            SendReleaseButtonToServer("Button_MENU");
        },

        // Exit
        onTouchStart_Button_EXIT(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }
            
            SendPressButtonToServer("Button_EXIT");
        },
        onTouchEnd_Button_EXIT(){
            SendReleaseButtonToServer("Button_EXIT");
        },

        // Select
        onTouchStart_Button_SELECT(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }

            SendPressButtonToServer("Button_SELECT");
            //SendOpenGame('IceHockey');
        },
        onTouchEnd_Button_SELECT(){
            SendReleaseButtonToServer("Button_SELECT");
        },

        // Start
        onTouchStart_Button_START(){
            if (Boolean(window.navigator.vibrate)) {
                window.navigator.vibrate(100);
            }
            
            SendPressButtonToServer("Button_START");
        },
        onTouchEnd_Button_START(){
            SendReleaseButtonToServer("Button_START");
        },

        //Axis Change
        onAxisChange(axis){
            SendAxisToServer(axis);
        },

        bgColor,
        buttonGlow,
        joystickGlow
 
    }
}

